/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfIgBusinessAccMediaDto } from '../../models/paginated-dto-of-ig-business-acc-media-dto';

export interface GetProfileMedia$Params {
}

export function getProfileMedia(http: HttpClient, rootUrl: string, params?: GetProfileMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfIgBusinessAccMediaDto>> {
  const rb = new RequestBuilder(rootUrl, getProfileMedia.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfIgBusinessAccMediaDto>;
    })
  );
}

getProfileMedia.PATH = '/api/v1/instagram/media';
